export enum DashboardRoute {
  Dashboard = "/v2/dashboard",
  Classes = "/v2/classes",
  Sparks = "/v2/sparks",
}
